// extracted by mini-css-extract-plugin
module.exports = {"demographice-container":"demographics_demographice-container__1xI0m","element":"demographics_element__pisWD"};